import {
  queryOptions,
  useMutation,
  type useQueryClient,
} from "@tanstack/react-query";
import * as API from "./index";
import type { UpdateManager } from "./type";

export const managerQueryFactory = {
  manager: "manager" as const,
  getManagerList: () => {
    return queryOptions({
      queryKey: [managerQueryFactory.manager, "list"],
      queryFn: API.getManagerList,
    });
  },
  getManagerCount: () => {
    return queryOptions({
      queryKey: [managerQueryFactory.manager, "count"],
      queryFn: API.getManagerCount,
    });
  },
  getManagerById: (id: number) => {
    return queryOptions({
      queryKey: [managerQueryFactory.manager, "detail", id],
      queryFn: () => API.getManagerById(id),
    });
  },
};

export const managerMutationFactory = {
  createManager: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.createManager,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [managerQueryFactory.manager, "list"],
          });
          toast.success("Manager created successfully");
        },
      });
    };
  },
  updateManager: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: (manager: { id: number; data: UpdateManager }) =>
          API.updateManager(manager.id, manager.data),
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [managerQueryFactory.manager],
          });
          toast.success("Manager updated successfully");
        },
      });
    };
  },
  deleteManager: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.deleteManager,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [managerQueryFactory.manager],
          });
          toast.success("Manager deleted successfully");
        },
      });
    };
  },
  checkEmailUnique: () => {
    return useMutation({
      mutationFn: API.checkEmailUnique,
    });
  },
};
